export enum UsuarioPerfil {
  THINKWAY_ADMIN = 'thinkway_admin',
  EMPRESA_ADMIN = 'empresa_admin',
  EMPRESA_USUARIO = 'empresa_usuario'
}